import { render } from "./WorkshopsSection.vue?vue&type=template&id=6466c7ae&scoped=true"
import script from "./WorkshopsSection.vue?vue&type=script&lang=js"
export * from "./WorkshopsSection.vue?vue&type=script&lang=js"

import "./WorkshopsSection.vue?vue&type=style&index=0&id=6466c7ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6466c7ae"]])

export default __exports__